import Clipboard from 'clipboard';
import * as bootstrap from 'bootstrap';

var myElement = document.getElementById('copyClip');
if (myElement) {
    // Element exists

    const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    );

    const myTooltipEl = document.getElementById('copyClip');
    const tooltip = bootstrap.Tooltip.getOrCreateInstance(myTooltipEl);

    myTooltipEl.addEventListener('click', () => {
        // do something...
        tooltip.setContent({ '.tooltip-inner': 'Tautan disalin' });

        setTimeout(function () {
            tooltip.setContent({ '.tooltip-inner': 'Salin Tautan' });
        }, 2000);
    });

    tooltip.hide();

    const target = document.getElementById('copyClip');
    var clipboard = new Clipboard(target);

    // clipboard.on('success', function (e) {
    //     const currentLabel = target.dataset.bsTitle;
    //     if (target.dataset.bsTitle === 'Copied!') {
    //         return;
    //     }

    //     target.dataset.bsTitle = 'Copied!';

    //     // Revert button label after 3 seconds
    //     setTimeout(function () {
    //         target.dataset.bsTitle = currentLabel;
    //     }, 3000);
    // });
    // clipboard.on('error', function () {
    //     document.body.insertAdjacentHTML(
    //         'beforeend',
    //         "<div>that didn't work.</div>"
    //     );
    // });
}
